module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[119]606.fa16223.woff2";